import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-loading-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-logo.component.html',
  styleUrl: './loading-logo.component.scss'
})
export class LoadingLogoComponent {
}
